import { useCallback } from 'react';
import { useToastContext } from '../context/ToastContext';

/**
 * Global toast notifications (fixed bottom corner, auto-dismiss, dismiss control).
 * Under ToastProvider (see App.js), queues toasts; otherwise no-ops (e.g. unit tests).
 */
export const useToast = () => {
  const ctx = useToastContext();
  const addToast = ctx?.addToast;
  const removeToast = ctx?.removeToast;

  const showToast = useCallback(
    (message, variant = 'info') => {
      if (addToast) {
        addToast(message, variant);
      }
    },
    [addToast],
  );

  return {
    showToast,
    dismissToast: removeToast ?? (() => {}),
    addToast: addToast ?? (() => null),
    removeToast: removeToast ?? (() => {}),
  };
};
